import { createUseStyles } from 'react-jss';
var useStyles = createUseStyles(function (theme) {
  var palette = theme.palette,
    radius = theme.radius;
  return {
    iconBackground: function iconBackground() {
      return {
        background: palette.warning.main,
        'border-radius': radius.large,
        height: '70px',
        width: '70px',
        display: 'flex',
        'justify-content': 'center',
        'align-items': 'center'
      };
    }
  };
});
export default useStyles;
//# sourceMappingURL=useStyles.js.map